var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-life-experience-pavilion-reservation',{ref:"table",staticClass:"pt-life-experience-pavilion-reservation__withData",attrs:{"waitAuditCount":_vm.waitAuditCount},on:{"reservationExport":_vm.reservationExport}})}
var staticRenderFns = []

export { render, staticRenderFns }